export default function() {

    var responsive = responsive || {};

    responsive.current_width = window.innerWidth;
    responsive.min_width = 992;
    responsive.mobile = responsive.current_width < responsive.min_width;

    var _cw = responsive.current_width;
    var _mw = responsive.min_width;
    var _w = window.innerWidth;
    var _toggle = (_cw >= _mw && _w < _mw) || (_cw < _mw && _w >= _mw);
    responsive.current_width = _w;
    responsive.mobile = responsive.current_width < responsive.min_width;

    return responsive.mobile;
}